import { createAction } from 'redux-action';

export const CHOOSE_PARENT = 'addon/parent/CHOOSE';
export const chooseParent = createAction(CHOOSE_PARENT);
